import {
	Alert,
	AppBar,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	Divider,
	FormControlLabel,
	IconButton,
	List,
	ListItem,
	Switch,
	TextField,
	Toolbar,
	Typography,
} from '@mui/material'
import Transition from 'components/Transition'
import CloseIcon from '@mui/icons-material/Close'
import CheckIcon from '@mui/icons-material/Check'
import SaveAsTwoToneIcon from '@mui/icons-material/SaveAsTwoTone'
import PhonelinkEraseIcon from '@mui/icons-material/PhonelinkErase'
import moment from 'moment'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { Box } from '@mui/system'
import { useEffect, useState } from 'react'
import { alertModal } from 'util/util'
import { SurveyAnswerSummaryType, SurveyMasterType } from 'constants/appType'

type SurveyAnswersPopupProps = {
	isOpen: boolean
	onClose: () => void
	data: SurveyMasterType | null
	subData: SurveyAnswerSummaryType[]
}

const SurveyAnswersPopup = ({
	isOpen,
	onClose,
	data,
	subData,
}: SurveyAnswersPopupProps) => {
	return (
		<Dialog
			open={isOpen}
			onClose={onClose}
			slots={{
				transition: Transition,
			}}
		>
			<AppBar sx={{ position: 'sticky' }}>
				<Toolbar>
					<Typography
						sx={{ flex: 1 }}
						variant="h6"
						component="div"
					>
						설문 결과
					</Typography>
					<IconButton
						edge="end"
						color="inherit"
						onClick={onClose}
						aria-label="close"
					>
						<CloseIcon />
					</IconButton>
				</Toolbar>
			</AppBar>
			<DialogContent>
				<Alert
					icon={<CheckIcon fontSize="inherit" />}
					severity="info"
					sx={{ mb: 2 }}
				>
					<strong>설문 제목</strong> : {data?.title} <br />
					<strong>설문 기간</strong> :{' '}
					{moment(data?.startDate).format('YYYY-MM-DD HH:mm')} ~{' '}
					{moment(data?.endDate).format('YYYY-MM-DD HH:mm')} <br />
					<strong>설문 문항 수</strong> : {subData.length}개
				</Alert>
				<Divider sx={{ mb: 2 }} />
				{subData.map((item: SurveyAnswerSummaryType, index) => (
					<Box
						key={index}
						sx={{
							mb: 2,
							p: 2,
							border: '1px solid #e0e0e0',
							borderRadius: 2,
							bgcolor: '#f9f9f9',
						}}
					>
						<Typography
							variant="h6"
							gutterBottom
						>
							{index + 1}. {item.question} (총 응답 수: {item.totalResponses}명)
						</Typography>

						{/* item.answer 는 | 문자 기준으로 잘라서 출력 */}
						<List>
							{item.answer.split('|').map((answerItem, answerIndex) => (
								<ListItem
									key={answerIndex}
									sx={{ pl: 4 }}
								>
									- {answerItem}
								</ListItem>
							))}
						</List>
					</Box>
				))}
			</DialogContent>
			<Divider />
			<DialogActions>
				<Button
					variant="contained"
					onClick={onClose}
					color="primary"
					size="small"
					startIcon={<PhonelinkEraseIcon />}
				>
					확인
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default SurveyAnswersPopup
